<template
    ><div class="pa-5" v-if="activeUser">
        <div
            v-for="(item, index) in activeUser.custom_links"
            :key="item.title + '_' + index"
            v-if="activeUser.custom_links && item.is_active"
        >
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Title" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.title ? item.title : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Open in" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.open_in ? item.open_in.charAt(0).toUpperCase() + item.open_in.slice(1) : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "URL" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.url ? item.url : "-" }}
                </v-col>
            </v-row>
            <v-divider class="my-2" />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "custom-links-tab",
    data() {
        return {};
    },
    computed: {
        ...mapState("UserStore", ["activeUser"])
    },
    methods: {}
};
</script>

<style scoped>
.row-title {
    color: gray;
}
.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}
.dot {
    margin-right: 10px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}
</style>
